/**
 * @file   src\components\Common\MyDrafts.js
 * @brief  This file is responsible for drafts section shown in create want ad page
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useEffect } from "react";
import noImage from "../../images/no-image-placeholder.png";
import { getLocalStorage } from "../../helpers/common";
import { INVENTORY_KEY, WANT_AD_KEY } from "../../constants/common";

const MyDrafts = (props) => {
  const {
    itemId,
    adType,
    CompletedPercentage,
    latUpdatedDate,
    locationAddress,
    Current_Step,
    clientName,
    isFromWantAd,
    setDraftSelectedItem,
    handleContinueButtonState,
    draftSelectedItem,
    InventoryPhoto,
    section,
    IsFilledByClient,
    IsReadyToReview,
  } = props;

  useEffect(() => {
    let details;
    if (section === "inventory") {
      details = getLocalStorage(INVENTORY_KEY);
    } else {
      details = getLocalStorage(WANT_AD_KEY);
    }

    const curentStep = _.get(details, "actvStep", null);
    if (curentStep === 1 && draftSelectedItem) {
      handleContinueButtonState();
    }
  }, [draftSelectedItem]);
  /**
   * To get the text displayed in draft section
   * @returns
   */
  const getDisplayText = () => {
    if (IsFilledByClient) {
      if (IsReadyToReview) {
        return "(Ready to Review)";
      } else {
        return "(Pending with Client)";
      }
    } else {
      return CompletedPercentage + "% complete";
    }
  };
  return (
    <>
      <div className="my-draftswrap-sec  mt-3">
        <label className="radio-wrap">
          <input
            name="SELL41"
            type="radio"
            value="false"
            disabled={IsFilledByClient && !IsReadyToReview}
            onChange={() =>
              setDraftSelectedItem({
                selectedId: itemId,
                currentStep: Current_Step,
              })
            }
          />
          <span>
            <div className="timing-wrap-info">
              <h6 className="pb-0 timing-wrap-head">
                {" "}
                {locationAddress ? locationAddress : adType + " Want listing"}
                {clientName && isFromWantAd ? ", " + clientName : ""}{" "}
                {getDisplayText()}
              </h6>
              {IsFilledByClient && !IsReadyToReview ? (
                <p> </p>
              ) : (
                <p className="timing-wrap-para">Last edited {latUpdatedDate}</p>
              )}
            </div>
            {section === "inventory" && (
              <div className="right-img-wrap">
                <img src={InventoryPhoto || noImage} />
              </div>
            )}
          </span>
        </label>
      </div>
    </>
  );
};
export default MyDrafts;
